// src/Components/ImageSliderWithVideo/ImageSliderWithVideo.tsx
import React from "react";
import SimpleImageSlider from "react-simple-image-slider";
import Iframe from "react-iframe";
import BlackBg from "Components/BlackBg/BlackBg";
import Header from "Components/Headers/Header";
import Footer from "Components/Footer";
import { projectSetups } from "../../config";

interface ImageSliderWithVideoProps {
  collectionKey: keyof typeof projectSetups;
}

const ImageSliderWithVideo = ({ collectionKey }: ImageSliderWithVideoProps) => {
  const collection = projectSetups[collectionKey];

  if (!collection) {
    return (
      <BlackBg>
        <div style={{ color: "white", padding: "2rem", textAlign: "center" }}>
          Project not found
        </div>
      </BlackBg>
    );
  }

  return (
    <BlackBg>
      {collection.headerProps && <Header {...collection.headerProps} />}

      {collection.images && collection.images.length > 0 ? (
        <SimpleImageSlider
          width={"100vw"}
          height={"100vh"}
          images={collection.images}
          style={{ backgroundPosition: "center center" }}
          showNavs={true}
          showBullets={false}
          slideDuration={1}
          autoPlayDelay={5}
          autoPlay={true}
        />
      ) : (
        <div style={{ color: "white", padding: "2rem", textAlign: "center" }}>
          No images available
        </div>
      )}

      {collection.video && (
        <Iframe
          url={collection.video}
          width="100%"
          display="block"
          styles={{
            height: "100vh",
            width: "100vw",
            zIndex: "2",
            backgroundColor: "black",
          }}
          position="relative"
          frameBorder={0}
          allowFullScreen={false}
        />
      )}

      <Footer />
    </BlackBg>
  );
};

export default ImageSliderWithVideo;
